import { Component, OnInit, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IDuplicateDNASampleResult } from '../../interfaces/duplicate-dna-sample-result';
import { UserService } from '../../services/user.service';
import { IUser } from '../../interfaces/user';
import { Permission } from '../../interfaces/permission.enum';

@Component({
    selector: 'app-duplicate-sample-popup',
    templateUrl: './duplicate-sample-popup.component.html',
    styles: [],
    standalone: false
})
export class DuplicateSamplePopupComponent implements OnInit {
  @Input() public newSample: IDuplicateDNASampleResult;
  @Input() public duplicateSamples: IDuplicateDNASampleResult[];
  @Output() public continue: EventEmitter<boolean> = new EventEmitter();

  @ViewChild("dupSamplePopup") dupSamplePopup: TemplateRef<any> = {} as TemplateRef<any>;

  public modalRef: NgbModalRef;
  public showVACORISNumber: boolean = false;

  constructor(private modalService: NgbModal, private readonly userService: UserService) { }

  ngOnInit(): void {
    let currentUser: IUser = this.userService.getCurrentUser();
    this.showVACORISNumber = currentUser.permissions.includes(Permission.ViewVACORISNumber);
  }

  public open(): void {
    this.modalRef = this.modalService.open(this.dupSamplePopup, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
  }

  public renderSSNs(ssns: string[]) {
    if (!ssns)
      return "";

    return ssns.join("<br />");
  }

  public onContinue(): void {
    this.modalRef.close();
    this.continue.emit(true);
  }
}
